
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-featured-content-references-field__wrapper{
    display:flex;
    flex-direction:column;
    margin:0;
    justify-content:center;
  }
  .se-featured-content-references-field__content{
    position:relative;
  }
  .se-featured-content-references-field__content ::slotted([slot='content']:not(:last-child))::after{
      content:'';
      width:100%;
      height:1px;
      background:white;
      position:absolute;
    }
`;